<template>
<div class="page page_tkdetail page_order">
    <!-- 退款状态 -->
    <div class="top">
        <div class="top_l">
            <div class="top_l_t">退款成功</div>
            <div class="top_l_b">2020年3月21日 22:55</div>
        </div>
        <div class="top_r">
            <span class="price"><span class="tag_cash">¥</span>430.00</span>
        </div>
    </div>
    <!-- 商品信息 -->
    <div class="list tkdetail">
        <div class="item">
            <div class="item_t">
                <img :src="publicPath+'statics/images/temp/touxiang.png'" alt="" class="thumb">
                <div class="title slh_s">勿忘初心勿忘初心勿忘初心勿忘初心勿忘初心勿忘初心勿忘初心勿忘初心</div>
            </div>
            <div class="item_nr">
                <div class="item_nr_l">
                    <img :src="publicPath+'statics/images/temp/ordertu.png'" alt="" class="tu">
                </div>
                <div class="item_nr_r">
                    <div class="item_nr_r_t">
                        <div class="title slh">传承计划之流素雅集传承计划之流素雅集传传承计划之流素雅集传承计划之流素雅集传</div>
                        <div class="info">
                            <span class="price"><span class="tag_cash">¥</span>215.00</span>
                            <span class="nums">x2</span>
                        </div>
                    </div>
                    <div class="sku">颜色：400cmx400cm 红色 （2只装）</div>
                </div>
            </div>
            <div class="item_nr">
                <div class="item_nr_l">
                    <img :src="publicPath+'statics/images/temp/ordertu.png'" alt="" class="tu">
                </div>
                <div class="item_nr_r">
                    <div class="item_nr_r_t">
                        <div class="title slh">传承计划之流素雅集传承计划之流素雅集传传承计划之流素雅集传承计划之流素雅集传</div>
                        <div class="info">
                            <span class="price"><span class="tag_cash">¥</span>215.00</span>
                            <span class="nums">x2</span>
                        </div>
                    </div>
                    <div class="sku">颜色：400cmx400cm 红色 （2只装）</div>
                </div>
            </div>
        </div>
        <!-- 退款信息 -->
        <div class="xinxi">
            <div class="xinxi_title">退款信息</div>
            <div class="xinxi_nr">
                <div class="">退款原因：拍错</div>
                <div class="">退款金额：¥430.00</div>
                <div class="">申请时间：2020-03-19 10:24:40</div>
                <div class="">订单编号：1584584680478870606998</div>
            </div>
        </div>
        <!-- 操作按钮 -->
        <div class="actions clearfix">
            <div class="action f-r">联系匠人</div>
        </div>
    </div>
</div>
</template>

<script>
import Vue from "vue";
import router from "../../../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../../../.././vuex/mutation_types";
import Bridge from "../../../../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;
export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,

        };
    },
    created: function () {
        // 获取列表
        this.getData();
    },
    methods: {
        // 获取列表
        getData() {
            var token = this.$store.getters.token;
            var param = {};
        },
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
